var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-mobile': _vm.isMobile },attrs:{"id":"app"}},[(_vm.loadOver && !['index', 'departCaseDetails', 'partyBuildDetails', 'departLandDetails', 'forLogin', 'msgDetails', 'socialLogin'].includes(_vm.$route.name) && _vm.$route.name !== null)?_c('base-home'):_vm._e(),_c('router-view',{attrs:{"isMobile":_vm.isMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }